import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

@Component({
	selector: 'app-inquiry',
	templateUrl: './inquiry.component.html',
	styleUrls: ['./inquiry.component.css']
})
export class InquiryComponent implements OnInit {

	admPageObj:any = "curr";

	frm : FormGroup;

	logi_user:any;
	inquiryList:any;

	/* 페이징 */
	cp:any = 1;
	paging:any = [];
	paging_start:any = [];
	paging_end:any = [];

	total_cnt:any = 0;

	/* 검색관련 */
	skey:any = "";
	sw:any = "";

	constructor(
		private http: HttpClient,
		public dialog: MatDialog,
		private fb: FormBuilder,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = fb.group({
			skey: [''],
			sw: [''],
		});
	}

	ngOnInit() {
	}

}
